function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

const SvgVimeo = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "16px",
    height: "16px",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65A2D9"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A7CA5"
    },
    d: "M388.741,143.1c-14.305,27.281-24.457,56.289-35.357,85.626  c-15.398-17.534-27.851-31.056-27.851-31.056h-42.696l-56.832-56.83l31.923,119.672l-91.57-67.722l-49.145,27.405l142.745,142.745  c-8.945,3.024-18.642,5.491-28.691,8.697L352.711,493.08c90.474-36.945,155.064-124.159,159.07-226.94L388.741,143.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M390.401,144.762c-7.096-7.646-17.368-11.717-30.527-12.104c-37.152-1.2-63.426,18.566-78.091,58.733  c-0.769,2.11-0.3,4.451,1.226,6.106c1.517,1.645,3.796,2.301,5.947,1.71c4.22-1.16,8.401-1.746,12.435-1.746  c5.413,0,12.621,0.995,16.208,5.735c2.75,3.641,3.125,9.097,1.11,16.219c-1.698,6.011-10.449,22.097-21.28,39.117  c-13.195,20.739-20.482,30.036-22.585,30.036c-6.959,0-32.116-111.547-32.809-113.993c-7.213-25.566-10.836-38.398-34.299-38.398  c-17.884,0-57.768,32.658-90.517,61.109c-2.015,1.746-3.71,3.22-5.022,4.346c-3.165,2.707-3.643,7.404-1.088,10.702l6.103,7.859  c2.572,3.313,7.259,4.006,10.68,1.576l0.336-0.241c10.593-7.537,20.604-14.655,28.16-15.048  c8.209-0.402,15.334,12.428,23.828,42.951c16.175,59.289,40.755,129.96,65.977,129.96c26.357,0,57.804-22.344,98.451-75.242  c36.788-47.875,56.489-85.845,57.751-113.473C403.346,169.817,399.31,154.365,390.401,144.762L390.401,144.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M390.401,144.762c-7.096-7.646-17.368-11.717-30.527-12.104c-37.152-1.2-63.426,18.566-78.091,58.733  c-0.769,2.11-0.3,4.451,1.226,6.106c1.517,1.645,3.796,2.301,5.947,1.71c4.22-1.16,8.401-1.746,12.435-1.746  c5.413,0,12.621,0.995,16.208,5.735c2.75,3.641,3.125,9.097,1.11,16.219c-1.698,6.011-10.449,22.097-21.28,39.117  c-13.195,20.739-20.482,30.036-22.585,30.036c-3.587,0-12.007-29.625-19.42-58.675v148.599  c24.426-4.613,53.212-27.479,89.219-74.342c36.788-47.875,56.489-85.845,57.751-113.473  C403.346,169.817,399.31,154.365,390.401,144.762z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVimeo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vimeo.77cd5fd4.svg";
export { ForwardRef as ReactComponent };